import { gql } from 'graphql-request'
import { Address, Timestamp } from '../../../utils/types'

export function h24Swaps(
  pool: Address,
  skip: number,
  start: Timestamp,
  end: Timestamp
) {
  return gql`
      {
          swaps(first: 1000, 
              skip:${skip},
              where:{
              poolAddress:"${pool}",
              timestamp_gt: ${start},
              timestamp_lt: ${end}
          },
              orderBy: timestamp,
              orderDirection: desc) {
              tokenIn
              tokenAmountIn
              tokenOut
              tokenAmountOut
              timestamp
              feeValue
              value
          }
      }
        `
}
